import cx from 'classnames'
import { WellCultureStatus } from '~/api/backend/pages/wellPageAPI'
import cs from './culture_status_text.scss'

export function CultureStatusText({
  status,
  className,
}: {
  status: WellCultureStatus
  className?: string
}) {
  return (
    <span
      className={cx(
        cs.statusText,
        status === 'Active' && cs.status__active,
        status === 'Terminated' && cs.status__terminated,
        className,
      )}
    >
      {status}
    </span>
  )
}
